import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isContactsPosition(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.CONTACTS_POSITION && typeof label === 'string' && typeof value === 'string';
}
function _formatContactsPosition(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatContactsPosition(submission) {
  if (isContactsPosition(submission)) {
    return _formatContactsPosition(submission);
  }
  return undefined;
}
//# sourceMappingURL=contacts-position-preview.js.map